import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/shop/reservations'

export default {
  async getById(id) {
    return await axios
      .get(endpoint + `/${id}`)
      .then(response => {
        return response.data.data
      });
  },
  async create(request) {
    return await axios
      .post(endpoint + '/create', request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async confirm(request) {
    return await axios
      .post(endpoint + '/confirm', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async cancel(request) {
    return await axios
      .post(endpoint + '/cancel', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/shop/reservation/instantReservationService.js